import { z } from 'zod';
export const FOLLOW_UP_ENGINE = ['legacy', 'rules'];
export const FOLLOW_UP_KIND = ['free', 'paid', 'discount'];
export const FOLLOW_UP_VALID_DAYS_MIN = 1;
export const FOLLOW_UP_VALID_DAYS_MAX = 365;
export const FOLLOW_UP_VALID_DAYS_DEFAULT = 7;
export const FOLLOW_UP_DISCOUNT_MIN = 1;
export const FOLLOW_UP_DISCOUNT_MAX = 99;
export const followUpValidDaysSchema = z.number().int().min(FOLLOW_UP_VALID_DAYS_MIN).max(FOLLOW_UP_VALID_DAYS_MAX);
export const closeFollowUpSchema = z
    .object({
    kind: z.enum(FOLLOW_UP_KIND),
    discountPct: z.number().int().min(FOLLOW_UP_DISCOUNT_MIN).max(FOLLOW_UP_DISCOUNT_MAX).optional(),
    validDays: followUpValidDaysSchema.optional(),
})
    .superRefine((value, context) => {
    if (value.kind === 'discount' && value.discountPct === undefined) {
        context.addIssue({ code: z.ZodIssueCode.custom, path: ['discountPct'], message: 'Say how much of the fee is taken off' });
    }
});
export function followUpTermsFor(offer) {
    if (offer.kind === 'free')
        return { isFreeFollowUp: true, followUpPricePct: 0 };
    if (offer.kind === 'discount' && offer.discountPct !== null) {
        return { isFreeFollowUp: false, followUpPricePct: 100 - offer.discountPct };
    }
    return { isFreeFollowUp: false, followUpPricePct: null };
}
export function storedDiscountPct(input) {
    return input.kind === 'discount' ? (input.discountPct ?? null) : null;
}
export function effectiveFollowUpPct(row) {
    return row.followUpPricePct ?? (row.isFreeFollowUp ? 0 : null);
}
export function priceForFollowUp(unitPriceMinor, pricePct) {
    if (pricePct === null)
        return unitPriceMinor;
    return Math.round((unitPriceMinor * pricePct) / 100);
}
//# sourceMappingURL=follow-up-entitlement.js.map